var map = {
	"assets/images/relics/WHM/relic_weapon-g_w_anima-p_w_animated.png": 5621,
	"assets/images/relics/WHM/relic_weapon-g_w_anima-p_w_awoken.png": 2149,
	"assets/images/relics/WHM/relic_weapon-g_w_anima-p_w_lux.png": 8141,
	"assets/images/relics/WHM/relic_weapon-g_w_resistance-p_w_blade.png": 8586,
	"assets/images/relics/WHM/relic_weapon-g_w_zodiac-p_w_animus.png": 8893,
	"assets/images/relics/WHM/relic_weapon-g_w_zodiac-p_w_atma.png": 6878,
	"assets/images/relics/WHM/relic_weapon-g_w_zodiac-p_w_nexus.png": 9161,
	"assets/images/relics/WHM/relic_weapon-g_w_zodiac-p_w_novus.png": 8503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8032;